import React  from 'react';
//import { Error500 } from '../HomePage/Error500';


class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false, 
            error: { message: '', stack: '' },
            info: { componentStack: '' }    
        };
    }

    componentDidCatch = (error, info) => {
        this.setState({ error, info });
    };

    static getDerivedStateFromError = error => {
        return { hasError: true };
    };

    render() {
        const { hasError} = this.state;
        const { children } = this.props;

        if (hasError) {
            return (
            <div className='card mt-4 sizer-text-center'>
                <br/><br/>
                <h2>We are sorry</h2>
                Something went wrong<br/>
                Please try to reload the page<br/><br/><br/><br/><br/>
                <span className='fs--2'>Err500</span>
            </div>)
        }
        else {
            return (children);
        }
    } 
}

export { ErrorBoundary }; 